import {Box, Flex, Text} from '@chakra-ui/react'
import {CommonColors} from '@utils/CommonStyles'
import {useSelector, useDispatch} from 'react-redux'
import {useEffect, useState} from 'react'
import {
  updateAudio,
  updateFooterData,
  updateIsShowFooter,
} from '@redux/paraphrase/paraphraseSlice'

const SelectAnswer = () => {
  const [selectedAnswer, setSelectedAnswer] = useState<number | null>(null)
  const dispatch = useDispatch()

  const {originSentence, colorsParaphrase, paraphraseData} = useSelector(
    (state: any) => state.paraphrase,
  )

  useEffect(() => {
    const audioData = {
      time: Date.now(),
      url: 'https://smedia.stepup.edu.vn/ielts/audio/paraphrase/chon_dap_an.wav',
    }
    dispatch(updateAudio(audioData))
  }, [])

  const handleSelectAnswer = (index: number) => {
    if (selectedAnswer !== null) return // Prevent selecting if already selected
    setSelectedAnswer(index)

    // Update footer data with selected answer
    const selectedOption = paraphraseData?.options[index]
    dispatch(updateFooterData(selectedOption))
    dispatch(updateIsShowFooter(true))
    setTimeout(() => {
      dispatch(
        updateAudio({
          time: Date.now(),
          url: paraphraseData?.practice_speaking?.audio_url || '',
        }),
      )
    }, 1000)
  }

  const getAnswerStyle = (item: any, index: number) => {
    if (selectedAnswer === null) return {}

    if (item.is_correct) {
      return {
        color: '#47CD89',
        border: '1px solid #2E8B57',
        bg: '#EBFFF4',
      }
    }

    if (selectedAnswer === index && !item.is_correct) {
      return {
        border: '1px solid #F97066',
        bg: '#FFECEC',
      }
    }

    return {}
  }

  return (
    <Box
      flexDirection={'column'}
      bg={'#fff'}
      p={{base: '16px', md: '32px'}}
      borderRadius={'24px'}
      h={'100%'}>
      <Text
        fontSize={{base: '16px', md: '18px'}}
        textTransform={'uppercase'}
        color={CommonColors.primary}>
        Chọn đáp án đúng
      </Text>
      <Flex columnGap={'16px'} flexWrap={'wrap'} mt={'24px'}>
        {originSentence?.highlight_items_en?.map((item: any, index: number) => {
          const colorScheme = item.content_words_order
            ? colorsParaphrase[item.content_words_order - 1]
            : null
          return (
            <Text
              key={index}
              fontSize={{base: '24px', sm: '32px', md: '40px'}}
              fontWeight={'600'}
              color={colorScheme?.color}>
              {item.words}
            </Text>
          )
        })}
      </Flex>
      <Flex
        flexDirection={'column'}
        gap={{base: '12px', md: '16px'}}
        mt={'24px'}>
        {paraphraseData?.options?.map((item: any, index: number) => {
          const label = String.fromCharCode(65 + index)
          return (
            <Text
              key={index}
              cursor={selectedAnswer === null ? 'pointer' : 'default'}
              fontSize={{base: '14px', md: '16px'}}
              border={'1px solid #EFEFEF'}
              p={{base: '12px', md: '16px'}}
              borderRadius={'8px'}
              onClick={() => handleSelectAnswer(index)}
              {...getAnswerStyle(item, index)}>
              {label}. {item.text}
            </Text>
          )
        })}
      </Flex>
    </Box>
  )
}

export default SelectAnswer
